module.exports = __webpack_public_path__ + "team-top.svg?a284f7000a93808e91b11891d1ec437f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/team-top.svg
// module id = 72
// module chunks = 0